import useGetDeviceNotesQuery from '@hooks/api/queries/notes/useGetDeviceNotesQuery';
import StickyNote2Icon from '@mui/icons-material/StickyNote2';
import { Box, IconButton, Tooltip } from '@mui/material';
import type { Actions } from '@src/types/Actions';
import storeConnector from '@store/storeConnector';
import type { MouseEvent } from 'react';
import notesx from './NotesSx';

interface NotesButtonProps {
  actions: Actions;
  className?: string;
  deviceId: string;
  size?: 'small' | 'medium' | 'large';
  deviceName: string;
}

function NotesButton({
  actions,
  className,
  deviceId,
  size,
  deviceName,
}: NotesButtonProps) {
  const { data } = useGetDeviceNotesQuery(deviceId);

  const handleClick = (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    actions.showNotesModal({
      isNotesOpen: true,
      deviceId,
      deviceName,
    });
  };

  return (
    <Tooltip title='Notes' placement='top'>
      <Box p={0}>
        <IconButton
          className={className}
          size={size ?? 'medium'}
          onClick={handleClick}
          sx={notesx.notesButton(data)}
        >
          <StickyNote2Icon fontSize='inherit' />
        </IconButton>
      </Box>
    </Tooltip>
  );
}

export default storeConnector(NotesButton, {});
